import React from 'react'
import { ContentDetailLoader } from '../content-detail/content-detail-loader'

import './index.scss'

export const FetchingModal = ({
  title = 'Fetching Data. Please wait',
}) => (
  <>
    <h2>{title}</h2>
    <ContentDetailLoader />
  </>
)
